import { useState, useEffect } from "react";
import { QREditorContextProps } from "@/contexts/QREditorContext/types";

export const useQRInitState = (qrEditorContext: QREditorContextProps<any> | null) => {
  const [isQRInit, setIsQRInit] = useState(
    qrEditorContext?.qrData?.qrCodeReference === undefined ? true : false
  );

  useEffect(() => {
    const data = qrEditorContext?.qrData.data || {};

    // Fields that NEVER should change the initial preview
    const QR_IGNORED_FIELDS = ["qrName", "themeColor", "typeName", "logoUrl"];

    // Filter only relevant fields for the content
    const contentFields = Object.keys(data).filter((key) => {
      if (QR_IGNORED_FIELDS.includes(key)) return false;

      // Exclude values that are placeholders
      const value = data[key];
      if (!value || value === "") return false;

      return true;
    });

    if (contentFields.length > 0) {
      setIsQRInit(false);
    }
  }, [qrEditorContext?.qrData.data]);

  return isQRInit;
};
